import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function Problem() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 px-6 bg-surface border-y border-taupe/30" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <h2 className="font-serif text-4xl md:text-5xl mb-12 text-center" data-id="element-129">
          {t.problem.h2Part1}{' '}
          <span className="italic text-coral" data-id="element-130">{t.problem.h2Italic}</span>{' '}
          {t.problem.h2Part2}
        </h2>

        <div className="space-y-8 text-lg text-ink/80 leading-relaxed" data-id="element-131">
          <p className="text-2xl font-serif text-ink text-center mb-12" data-id="element-132">
            {t.problem.intro}
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-133">
            <div className="p-8 border border-taupe bg-cream rounded-2xl" data-id="element-134">
              <p className="text-sm font-medium text-muted uppercase tracking-wider mb-2" data-id="element-135">
                {t.problem.layer1Label}
              </p>
              <p className="text-xl" data-id="element-136">{t.problem.layer1Text}</p>
            </div>
            <div className="p-8 border border-coral/20 bg-coral/5 rounded-2xl" data-id="element-137">
              <p className="text-sm font-medium text-coral uppercase tracking-wider mb-2" data-id="element-138">
                {t.problem.layer2Label}
              </p>
              <p className="text-xl italic" data-id="element-139">{t.problem.layer2Text}</p>
            </div>
          </div>

          <p data-id="element-140">{t.problem.p1}</p>
          <p data-id="element-141">{t.problem.p2}</p>
          <p className="font-medium text-ink pt-4" data-id="element-142">{t.problem.p3}</p>
        </div>
      </div>
    </section>;
}